module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "question-wrapper"
  }, [_c('detail-title', {
    attrs: {
      "title": _vm.isAnswer ? '问答专区' : '文章专区',
      "isShowTitle": _vm.isShowTitle,
      "detailInfo": _vm.detailInfo,
      "isPreview": true,
      "isAnswer": _vm.isAnswer
    },
    on: {
      "toPersonal": _vm.toPersonal
    }
  }), _vm._v(" "), _c('section', {
    staticClass: "content-wrapper"
  }, [_c('div', {
    staticClass: "center-content"
  }, [_c('div', {
    staticClass: "center-top-content"
  }, [_c('div', {
    staticClass: "basic-info"
  }, [(_vm.detailInfo.created_by) ? _c('div', {
    staticClass: "questioner-info"
  }, [_c('span', {
    staticClass: "user-portrait",
    on: {
      "click": _vm.toPersonal
    }
  }, [(_vm.detailInfo.created_by.avatar.substr(0, 1) == '?') ? _c('img', {
    staticClass: "identity-icon",
    attrs: {
      "width": "26",
      "height": "26",
      "src": require("../../images/personal_center/avatar_default.png")
    }
  }) : _c('img', {
    attrs: {
      "src": _vm.detailInfo.created_by.avatar,
      "alt": "",
      "width": "26",
      "height": "26"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "questioner-name"
  }, [_vm._v(_vm._s(_vm.detailInfo.created_by.nick_name))]), _vm._v(" "), _c('span', {
    staticClass: "question-time"
  }, [_vm._v("于" + _vm._s(_vm.detailInfo.updated_on))]), _vm._v(" "), _c('span', [_vm._v("发布")])]) : _vm._e(), _vm._v(" "), _c('ul', {
    staticClass: "tags"
  }, _vm._l((_vm.detailInfo.tags), function(item, index) {
    return _c('li', {
      key: index
    }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(item.title) + "\n\t\t\t\t\t\t\t")])
  }), 0)]), _vm._v(" "), (_vm.detailInfo.description !== '<p><br></p>' && _vm.detailInfo.description !== '') ? _c('div', {
    staticClass: "question-content markdown-body"
  }, [_c('p', {
    ref: "descHook",
    staticClass: "question-desc img-hook",
    domProps: {
      "innerHTML": _vm._s(_vm.filterXSS(_vm.afterhtmlData))
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.getImgUrl($event)
      }
    }
  })]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "right-content"
  }, [(_vm.detailInfo.tags) ? _c('communityRightContent', {
    ref: "rightChild",
    attrs: {
      "tags": _vm.detailInfo.tags,
      "isAnswer": _vm.isAnswer
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('goback')], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-44b2ef56!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/community/preview.vue
// module id = LKkw
// module chunks = 15